export const state = {
  sideLinks: null,
  showNavItems: true,
}

export const mutations = {
  ADD_SIDE_LINKS(state, payload) {
    state.sideLinks = payload
  },
  TOGGLE_DISPLAY(state, payload) {
    state.showNavItems = payload
  },
}

export const actions = {
  addSideLinks({ commit }, { sideLinks }) {
    commit('ADD_SIDE_LINKS', sideLinks)
  },
  toggleDisplay({ commit }, { bool }) {
    commit('TOGGLE_DISPLAY', bool)
  },
}
